import { validateUF } from 'validations-br';

class UFValidatorAdapter {
  isValid (uf) {
    return validateUF(uf);
  }
}

export default UFValidatorAdapter;
